import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CatalogueComponent } from './catalogue/catalogue.component';
import {CatlogueReferComponent } from './catlogue-refer/catlogue-refer.component';

const routes: Routes = [
  { path: '', component: CatalogueComponent },
  { path: 'catalogue-partner', component: CatalogueComponent },
  { path: 'catalogue-refer', component: CatlogueReferComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogueRoutingModule { }
